import {UI_CSS} from './uiCss';

/**
 * The shared stylesheet, in the document, exactly once.
 *
 * `href` + `precedence` are React 19's stylesheet de-duplication: a `<style>`
 * carrying both is hoisted into `<head>` and rendered **once** no matter how
 * many components render it. That is what lets `Screen` render this itself
 * rather than relying on `App` to do it — which matters more than it sounds,
 * because a test that mounts a single screen instead of the whole app would
 * otherwise get an unstyled one, and the geometry assertions this stylesheet
 * exists to make possible would quietly measure nothing.
 *
 * `precedence="pokpok-ui"` puts it in its own bucket. It is below `global.css`
 * in intent but does not rely on being below it in order: every rule in
 * `uiCss.ts` is class-based, so it beats `global.css`'s bare element selectors
 * on specificity whichever way the bundler orders them. Order-independence is
 * the point — the one thing that will not break the day the CSS pipeline
 * changes.
 *
 * Children are a plain string, not `dangerouslySetInnerHTML`: React's hoisting
 * only applies to the string form, and the content is this application's own
 * design tokens rather than anything a guest or merchant can influence.
 */
export function UiStyles() {
  return (
    <style href="pokpok-ui" precedence="pokpok-ui">
      {UI_CSS}
    </style>
  );
}
